"use client";

import { TolgeeProvider } from "@tolgee/react";
import type { TolgeeStaticData } from "@tolgee/react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { TolgeeBase } from "./shared";

const tolgee = TolgeeBase().init();

type TolgeeNextProviderProps = {
  language: string;
  staticData: TolgeeStaticData;
  children: React.ReactNode;
};

export const TolgeeNextProvider = ({
  language,
  staticData,
  children,
}: TolgeeNextProviderProps) => {
  const router = useRouter();

  useEffect(() => {
    const { unsubscribe } = tolgee.on("permanentChange", () => {
      router.refresh();
    });

    return () => unsubscribe();
  }, [router]);

  return (
    <TolgeeProvider
      tolgee={tolgee}
      fallback={children}
      options={{ useSuspense: false }}
      ssr={{ language, staticData }}
    >
      {children}
    </TolgeeProvider>
  );
};
